import { Lock, Zap, CheckCircle, ShieldCheck } from "lucide-react";
import logoHotmart from "@/assets/logo-hotmart.png";
const TrustBadge = () => {
  return <section className="relative overflow-hidden py-12 sm:py-16 gradient-hero">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      </div>
      <div className="container-centered relative z-10">
        <div className="mx-auto max-w-4xl">
          {/* Main Badge Card */}
          <div className="rounded-3xl p-8 shadow-lg sm:p-12 border-2 border-primary/20 bg-gray-600 text-secondary-foreground">
            <div className="flex flex-col items-center gap-6 text-center bg-slate-800">
              {/* Hotmart Logo Badge */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 rounded-2xl px-8 py-4 bg-[#0e0f10]">
                <img src={logoHotmart} alt="Hotmart" className="h-10 w-auto object-contain" />
                <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
                  <span className="font-display text-2xl sm:text-3xl font-bold tracking-wide text-secondary-foreground">
                    HOTMART
                  </span>
                  <span className="text-sm text-secondary-foreground">Plataforma Segura</span>
                </div>
              </div>

              <h2 className="font-display text-2xl font-bold sm:text-3xl lg:text-4xl text-secondary-foreground">
                🔒 Compra 100% Segura
              </h2>

              {/* Trust Points */}
              <div className="mt-4 flex flex-wrap items-center justify-center gap-6 text-secondary-foreground">
                <div className="flex items-center gap-3 bg-gradient-to-r from-teal-500/20 via-cyan-400/20 to-amber-500/20 rounded-full px-5 py-3">
                  <CheckCircle className="h-6 w-6 text-cyan-400" />
                  <span className="text-base font-semibold text-secondary-foreground">Pago protegido</span>
                </div>
                <div className="flex items-center gap-3 bg-gradient-to-r from-teal-500/20 via-cyan-400/20 to-amber-500/20 rounded-full px-5 py-3">
                  <CheckCircle className="h-6 w-6 text-cyan-400" />
                  <span className="text-base font-semibold text-secondary-foreground">Garantía 60 días</span>
                </div>
                <div className="flex items-center gap-3 bg-gradient-to-r from-teal-500/20 via-cyan-400/20 to-amber-500/20 rounded-full px-5 py-3">
                  <CheckCircle className="h-6 w-6 text-cyan-400" />
                  <span className="text-base font-semibold text-secondary-foreground">Acceso inmediato</span>
                </div>
              </div>

              {/* Description */}
              <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-secondary-foreground">
                Tu compra está procesada a través de <strong className="bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent font-bold">Hotmart</strong>, 
                la plataforma líder en productos digitales con más de{" "}
                <strong className="bg-gradient-to-r from-teal-400 via-cyan-300 to-amber-400 bg-clip-text text-transparent font-bold">20 millones de usuarios</strong> en todo el mundo.
              </p>

              {/* Security Icons */}
              <div className="mt-8 flex items-center gap-8 sm:gap-12">
                <div className="flex flex-col items-center gap-2">
                  <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 text-slate-900 shadow-lg">
                    <Lock className="h-8 w-8" />
                  </div>
                  <span className="text-sm font-medium text-foreground">SSL Seguro</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 text-slate-900 shadow-lg">
                    <ShieldCheck className="h-8 w-8" />
                  </div>
                  <span className="text-sm font-medium text-foreground">Datos Protegidos</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                  <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-teal-500 via-cyan-400 to-amber-500 text-slate-900 shadow-lg">
                    <Zap className="h-8 w-8" />
                  </div>
                  <span className="text-sm font-medium text-foreground">Acceso Inmediato</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default TrustBadge;